<template>
  <v-container id="login" class="fill-height" tag="section">
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card color="#cb9999" light width="100%" max-width="400" min-width="150" class="px-5 py-3">
          <template v-slot:heading>
            <div class="text-center">
              <h1
                class="display-2 font-weight-bold mb-2"
                style="margin: 0px !important;"
              >Hairtalk Portal</h1>
            </div>
          </template>

          <form @submit.prevent="onSubmit">
            <v-card-text class="text-center">
              <v-text-field
                color="secondary"
                label="Email..."
                prepend-icon="mdi-email"
                v-model="user.username"
                autocomplete="new-password"
                name="username"
                data-vv-as="Username"
                v-validate="validators.username"
                :error="getError('username')"
              />

              <v-text-field
                class="mb-8"
                color="secondary"
                label="Password..."
                prepend-icon="mdi-lock-outline"
                v-model="user.password"
                type="password"
                autocomplete="new-password"
                name="password"
                data-vv-as="Password"
                v-validate="validators.password"
                :error="getError('password')"
              />

              <pages-btn type="submit" large color depressed class="v-btn--text success--text">Login</pages-btn>
            </v-card-text>
          </form>
          <div class="text-center ma-2">
            <v-snackbar v-model="snackbar" :color="snackColor">
              {{ message }}
              <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
          </div>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
import axios from "../../utils/axios";
import tokenStore from "../../utils/tokenStore";
export default {
  name: "PagesLogin",

  components: {
    PagesBtn: () => import("./components/Btn")
  },
  created() {
    tokenStore.clearToken();
  },
  data() {
    return {
      user: {
        username: "",
        password: ""
      },
      validators: {
        username: {
          required: true
        },
        password: {
          required: true
        }
      },
      snackbar: false,
      message: "",
      snackColor: "error"
    };
  },
  methods: {
    async onSubmit() {
      this.$validator.validateAll().then(async isValid => {
        if (isValid) {
          let loader = this.$loading.show();
          try {
            var result = await axios.post(
              "/users/authenticate",
              JSON.parse(
                '{ "username": "' +
                  this.user.username +
                  '", "password": "' +
                  this.user.password +
                  '" }'
              )
            );
            if (result) {
              tokenStore.setToken(result.data.token);
              this.$router.push({ path: "/" });
            } else {
              throw "Invalid username or password";
            }
          } catch (exception) {
            this.message = exception;
            this.snackbar = true;
          } finally {
            loader.hide();
          }
        } else {
          this.message = this.errors.items[0].msg;
          if (this.errors.items.length > 1) {
            for (let index = 1; index < this.errors.items.length; index++) {
              this.message +=
                " and " + this.errors.items[index].msg.toLowerCase();
            }
          }
          this.snackbar = true;
        }
      });
    },
    getError(fieldName) {
      if(this.errors.first(fieldName) !== undefined){
        return true;
      }
      return false;
    },
  }
};
</script>
